import { Dto } from '@mango/core';
import { OproepHistorie } from './oproep-historie';
import { Pakbon } from './pakbon';

@Dto({fullName: "CIJBorculo.Logic.OproepBijlage"})
export class oproepBijlage {
    oproephistorie?: OproepHistorie[];    
}
